import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {generate} from '../../../../routes.js';
import conf from '../../../../conf.js';
import SearchResults from '../../../Search/Components/SearchResults.jsx';
import OfferSearchCard from '../../../../components/SearchCard/Offer/OfferSearchCard.jsx';

export default class OfferSearchResults extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    flattenSearchObject: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    search: PropTypes.func.isRequired,
    searchQuery: PropTypes.object.isRequired,
    searchRouteName: PropTypes.string.isRequired,
    searchTarget: PropTypes.string.isRequired,
  };

  static topologies = [
    [
      {name: 'filled', label: 'Pourvue', value: conf.search.topologies.offers.filled},
      {name: 'not_filled', label: 'Non pourvue', value: conf.search.topologies.offers.notFilled}
    ],
    [
      {name: 'published', label: 'Publiée', value: conf.search.topologies.offers.published},
      {name: 'not_published', label: 'Non publiée', value: conf.search.topologies.offers.notPublished}
    ],
    [
      {name: 'locked', label: 'Verrouillée', value: conf.search.topologies.offers.locked},
      {name: 'not_locked', label: 'Non verrouillée', value: conf.search.topologies.offers.notLocked}
    ],
  ];

  static filters = {
    orders: [
      {
        name: 'publication_sort',
        label: 'Publication',
        tooltip: 'Tri sur la date de publication',
        mustBeAdmin: true,
      },
      {
        name: 'filled_sort',
        label: 'Provision',
        tooltip: 'Tri sur la date de provision',
        mustBeAdmin: true,
      },
      {
        name: 'created_sort',
        label: 'Création',
        tooltip: 'Tri sur la date de création',
        mustBeAdmin: true,
      }
    ],
    adminOnlyRequirements: false,
    requirementChoices: [
      {text: 'Défaut'},
      {value: 1, text: 'ID (Sans le #)'},
    ]
  };

  generateLink = (search, offset) => generate({
    name: 'offers.search.viewer.views',
    parameters: {offset, page: this.props.searchQuery.page},
    search: search
  });

  renderOffers = (offers) => {
    const search = this.props.flattenSearchObject(this.props.searchQuery);

    const offerItems = offers.map((offer, index) =>
      <OfferSearchCard
        currentUser={this.props.currentUser}
        isAdmin={this.props.isAdmin}
        key={offer.id}
        link={this.generateLink(search, index)}
        offer={this.expandOffer(offer)}
      />
    );

    return <div className="row">{offerItems}</div>;
  };

  expandOffer = (offer) => {
    return {
      ...offer,
      city: Array.isArray(offer.city) ? offer.city : [offer.city],
      keywords: offer.keywords ? offer.keywords.map(keyword => ({name: keyword})) : [],
      secteurs: offer.secteurs ? offer.secteurs.map(secteur => ({name: secteur})) : [],
    }
  };

  render() {
    return (
      <SearchResults
        filters={OfferSearchResults.filters}
        flattenSearchObject={this.props.flattenSearchObject}
        isAdmin={this.props.isAdmin}
        isCity={{all: true, remote: false, placeholder: '100km autour de ...'}}
        isManager={true}
        isOnlyMy={!!this.props.currentUser && !this.props.isAdmin && this.props.currentUser?.complete}
        loading={this.props.loading}
        search={this.props.search}
        renderResults={this.renderOffers}
        searchQuery={this.props.searchQuery}
        searchRouteName={this.props.searchRouteName}
        searchData={this.props.searchData}
        topologies={OfferSearchResults.topologies}
        target={this.props.searchTarget}
      />
    );
  }
}